import Vue from "vue";
import VueCarousel from 'vue-carousel';
import AboutQuotes from './components/AboutQuotes.vue';

Vue.use(VueCarousel);

Vue.component('aboutQuotes', AboutQuotes);

new Vue({el: '#about-quotes'});
